module.exports = __webpack_public_path__ + "static/img/96002C_2_R_20200401_LC.8f86f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/96002C_2_R_20200401_LC.png
// module id = 0MBR
// module chunks = 0